<main [ngClass]="{ 'flex flex-col h-full overflow-hidden': drawerStyle }" class="bg-white rounded">
  <header class="p-5 flex flex-row items-center justify-between">
    @if (title) {
      <p class="text-ts-header-title font-ts-header-title">{{ title }}</p>
    } @else {
      <ng-content #headerTemplate select="[ts-dialog-header]"></ng-content>
    }
    @if (!hideCloseButton) {
      <button class="ts-dialog-close flex flex-row items-center ml-auto" (click)="closeDialog.emit()">
        <ts-icon color="black" icon="close"></ts-icon>
      </button>
    }
  </header>
  <ts-divider spacing="none" />
  <section [ngClass]="{ 'flex-1 px-5 overflow-auto': drawerStyle, 'p-5': !drawerStyle }">
    <ng-content select="[ts-dialog-body]"></ng-content>
  </section>
  @if (showFooter) {
    <ts-divider spacing="none" />
    <footer class="p-5 flex flex-row justify-between items-center">
      <div>
        <ng-content select="[ts-dialog-footer-left]"></ng-content>
      </div>
      <ng-content select="[ts-dialog-actions]"></ng-content>
    </footer>
  }
</main>
